import React, { forwardRef } from 'react';

import RadioM, { RadioProps } from '@mui/material/Radio';

import Icon from '../Icon/Icon.jsx';

/**
 * @deprecated Use RadioGroup components from @mint-lib/tw-components instead
 */
const Radio = forwardRef(
  (props: RadioProps, ref: React.ForwardedRef<HTMLButtonElement>) => {
    return (
      <RadioM
        checkedIcon={<Icon component="RadioButtonChecked" />}
        icon={<Icon component="RadioButton" />}
        className={`${props.readOnly ? 'readonly-radio' : ''} ${props.className}`}
        {...props}
        ref={ref}
      />
    );
  },
);

export default Radio;
